import * as types from "../../mutation-types";

const mutations = {
    [types.SET_SM_PARTNERS]: (state, payload) => {
        state.sm_partners = payload;
    },
    [types.SET_SM_PARTNER]: (state, payload) => {
        state.sm_partner = payload;
    },
    [types.ADD_SM_PARTNER_ITEM]: (state, payload) => {
        state.sm_partners.push(payload);
    },
    [types.UPDATE_SM_PARTNER_ITEM]: (state, payload) => {
        state.sm_partners.splice(state.sm_partners.indexOf(
            state.sm_partners.find(c => c.uuid === payload.uuid)
        ), 1, payload);
    },
    [types.DELETE_SM_PARTNER_ITEM]: (state, payload) => {
        state.sm_partners.splice(state.sm_partners.indexOf(
            state.sm_partners.find(c => c.uuid === payload.uuid)
        ), 1);
    },
    [types.SET_SM_PARTNER_TYPES]: (state, payload) => {
      state.sm_partner_types = payload;
    },
     [types.SET_SM_PARTNER_LEGAL_FORMS]: (state, payload) => {
      state.sm_partner_legal_forms = payload;
    },
}

export default mutations;
